const trackDurations = {
  "other-stories-single": {
    "source": "https://mewithoutyou.bandcamp.com/album/other-stories-single",
    "tracks": [
      {
        "title": "Julian the Onion",
        "seconds": 243
      },
      {
        "title": "Four Fires",
        "seconds": 216
      }
    ]
  },
  "brother-sister": {
    "source": "https://mewithoutyou.bandcamp.com/album/brother-sister",
    "tracks": [
      {
        "title": "Messes of Men",
        "seconds": 232
      },
      {
        "title": "The Dryness and The Rain",
        "seconds": 177
      },
      {
        "title": "Wolf Am I! (and Shadow)",
        "seconds": 156
      },
      {
        "title": "Yellow Spider",
        "seconds": 70
      },
      {
        "title": "A Glass Can Only Spill What It Contains",
        "seconds": 225
      },
      {
        "title": "Nice and Blue (pt. Two)",
        "seconds": 223
      },
      {
        "title": "The Sun and The Moon",
        "seconds": 315
      },
      {
        "title": "Orange Spider",
        "seconds": 70
      },
      {
        "title": "C-Minor",
        "seconds": 201
      },
      {
        "title": "In a Market Dimly Lit",
        "seconds": 267
      },
      {
        "title": "O, Porcupine",
        "seconds": 271
      },
      {
        "title": "Brownish Spider",
        "seconds": 79
      },
      {
        "title": "In a Sweater Poorly Knit",
        "seconds": 326
      }
    ]
  },
  "pale-horses": {
    "source": "https://mewithoutyou.bandcamp.com/album/pale-horses",
    "tracks": [
      {
        "title": "Pale Horse",
        "seconds": 145
      },
      {
        "title": "Watermelon Ascot",
        "seconds": 188
      },
      {
        "title": "D-Minor",
        "seconds": 199
      },
      {
        "title": "Mexican War Streets",
        "seconds": 214
      },
      {
        "title": "Red Cow",
        "seconds": 239
      },
      {
        "title": "Dorothy",
        "seconds": 99
      },
      {
        "title": "Blue Hen",
        "seconds": 185
      },
      {
        "title": "Lilac Queen",
        "seconds": 238
      },
      {
        "title": "Magic Lantern Days",
        "seconds": 232
      },
      {
        "title": "Birnam Wood",
        "seconds": 257
      },
      {
        "title": "Rainbow Signs",
        "seconds": 363
      }
    ]
  },
  "catch-for-us-the-foxes": {
    "source": "https://mewithoutyou.bandcamp.com/album/catch-for-us-the-foxes",
    "tracks": [
      {
        "title": "Torches Together",
        "seconds": 227
      },
      {
        "title": "January, 1979",
        "seconds": 206
      },
      {
        "title": "Tie Me Up! Untie Me!",
        "seconds": 221
      },
      {
        "title": "Leaf",
        "seconds": 217
      },
      {
        "title": "Disaster Tourism",
        "seconds": 179
      },
      {
        "title": "Seven Sisters",
        "seconds": 228
      },
      {
        "title": "The Soviet",
        "seconds": 183
      },
      {
        "title": "Paper Hanger",
        "seconds": 252
      },
      {
        "title": "My Exit, Unfair!",
        "seconds": 232
      },
      {
        "title": "Four Word Letter (pt. Two)",
        "seconds": 262
      },
      {
        "title": "Carousels",
        "seconds": 342
      },
      {
        "title": "Son of a Widow",
        "seconds": 206
      }
    ]
  },
  "pale-horses-appendix": {
    "source": "https://mewithoutyou.bandcamp.com/album/pale-horses-appendix",
    "tracks": [
      {
        "title": "Hebrew Children",
        "seconds": 118
      },
      {
        "title": "Werewolf King (demo)",
        "seconds": 199
      },
      {
        "title": "Chapelcross Towns",
        "seconds": 177
      },
      {
        "title": "Chornobyl, 1985",
        "seconds": 261
      },
      {
        "title": "Mexican War Streets (revisited)",
        "seconds": 213
      },
      {
        "title": "Blue Hen (Geology Version)",
        "seconds": 192
      },
      {
        "title": "Fairfield",
        "seconds": 135
      },
      {
        "title": "Red Cow (Golden Calf Version)",
        "seconds": 809
      }
    ]
  },
  "ten-stories": {
    "source": "https://mewithoutyou.bandcamp.com/album/ten-stories",
    "tracks": [
      {
        "title": "February, 1878",
        "seconds": 226
      },
      {
        "title": "Grist for the Malady Mill",
        "seconds": 197
      },
      {
        "title": "East Enders Wives",
        "seconds": 172
      },
      {
        "title": "Cardiff Giant",
        "seconds": 223
      },
      {
        "title": "Elephant in the Dock",
        "seconds": 231
      },
      {
        "title": "Aubergine",
        "seconds": 194
      },
      {
        "title": "Fox&#39;s Dream of the Log Flume",
        "seconds": 224
      },
      {
        "title": "Nine Stories",
        "seconds": 286
      },
      {
        "title": "Fiji Mermaid",
        "seconds": 214
      },
      {
        "title": "Bear&#39;s Vision of St. Agnes",
        "seconds": 299
      },
      {
        "title": "All Circles",
        "seconds": 164
      }
    ]
  },
  "a-b-life": {
    "source": "https://mewithoutyou.bandcamp.com/album/a-b-life",
    "tracks": [
      {
        "title": "Bullet to Binary",
        "seconds": 167
      },
      {
        "title": "The Ghost",
        "seconds": 193
      },
      {
        "title": "Nice and Blue",
        "seconds": 234
      },
      {
        "title": "Everything Was Beautiful and Nothing Hurt",
        "seconds": 284
      },
      {
        "title": "(A)",
        "seconds": 54
      },
      {
        "title": "Gentlemen",
        "seconds": 169
      },
      {
        "title": "Be Still, Child",
        "seconds": 161
      },
      {
        "title": "We Know Who Our Enemies Are",
        "seconds": 178
      },
      {
        "title": "I Never Said That I Was Brave",
        "seconds": 181
      },
      {
        "title": "(B)",
        "seconds": 94
      },
      {
        "title": "Silencer",
        "seconds": 229
      },
      {
        "title": "The Cure For Pain",
        "seconds": 908
      }
    ]
  },
  "live-vol-one": {
    "source": "https://mewithoutyou.bandcamp.com/album/live-vol-one",
    "tracks": [
      {
        "title": "Song #1",
        "seconds": 209
      },
      {
        "title": "Song #2",
        "seconds": 254
      },
      {
        "title": "Song #3",
        "seconds": 255
      },
      {
        "title": "Song #4",
        "seconds": 156
      },
      {
        "title": "Song #5",
        "seconds": 205
      },
      {
        "title": "Song #6",
        "seconds": 199
      },
      {
        "title": "Song #7",
        "seconds": 245
      },
      {
        "title": "Song #8",
        "seconds": 241
      },
      {
        "title": "Song #9",
        "seconds": 263
      },
      {
        "title": "Song #10",
        "seconds": 184
      },
      {
        "title": "Song #11",
        "seconds": 216
      },
      {
        "title": "Song #12",
        "seconds": 250
      },
      {
        "title": "Song #13",
        "seconds": 369
      },
      {
        "title": "Song #14",
        "seconds": 198
      },
      {
        "title": "Song #15",
        "seconds": 314
      },
      {
        "title": "Song #16",
        "seconds": 251
      },
      {
        "title": "Song #17",
        "seconds": 225
      }
    ]
  },
  "east-enders-wives-maxi-single": {
    "source": "https://mewithoutyou.bandcamp.com/album/east-enders-wives-maxi-single",
    "tracks": [
      {
        "title": "East Enders Wives (Album Version)",
        "seconds": 179
      },
      {
        "title": "East Enders Wives (Orchestral Version)",
        "seconds": 178
      },
      {
        "title": "East Enders Wives (Remix)",
        "seconds": 274
      },
      {
        "title": "East Enders Wives (Demo)",
        "seconds": 184
      },
      {
        "title": "East Enders Wives (Instrumental)",
        "seconds": 179
      },
      {
        "title": "East Enders Wives (Remix Instrumental)",
        "seconds": 272
      }
    ]
  },
  "its-all-crazy-its-all-false-its-all-a-dream-its-alright": {
    "source": "https://mewithoutyou.bandcamp.com/album/its-all-crazy-its-all-false-its-all-a-dream-its-alright",
    "tracks": [
      {
        "title": "Every Thought a Thought of You",
        "seconds": 211
      },
      {
        "title": "The Fox, the Crow, and the Cookie",
        "seconds": 210
      },
      {
        "title": "The Angel of Death Came to David&#39;s Room",
        "seconds": 233
      },
      {
        "title": "Goodbye, i!",
        "seconds": 229
      },
      {
        "title": "A Stick, a Carrot, and String",
        "seconds": 186
      },
      {
        "title": "Bullet to Binary (pt. Two)",
        "seconds": 312
      },
      {
        "title": "Timothy Hay",
        "seconds": 217
      },
      {
        "title": "Fig With a Bellyache",
        "seconds": 210
      },
      {
        "title": "Cattail Down",
        "seconds": 226
      },
      {
        "title": "The King Beetle on a Coconut Estate",
        "seconds": 361
      },
      {
        "title": "الله الله الله",
        "seconds": 294
      }
    ]
  },
  "untitled": {
    "source": "https://mewithoutyou.bandcamp.com/album/untitled",
    "tracks": [
      {
        "title": "9:27a.m., 7/29",
        "seconds": 141
      },
      {
        "title": "Julia (or, &#39;Holy to the LORD&#39; on the Bells of Horses)",
        "seconds": 237
      },
      {
        "title": "Another Head for Hydra",
        "seconds": 163
      },
      {
        "title": "[dormouse sighs]",
        "seconds": 254
      },
      {
        "title": "Winter Solstice",
        "seconds": 232
      },
      {
        "title": "Flee, Thou Matadors!",
        "seconds": 297
      },
      {
        "title": "Tortoises All the Way Down",
        "seconds": 273
      },
      {
        "title": "2,459 Miles",
        "seconds": 146
      },
      {
        "title": "Wendy & Betsy",
        "seconds": 131
      },
      {
        "title": "New Wine, New Skins",
        "seconds": 284
      },
      {
        "title": "Michael, Row Your Boat Ashore",
        "seconds": 312
      },
      {
        "title": "Break on Through (to the Other Side) [pt. Two]",
        "seconds": 114
      }
    ]
  },
  "live-vol-two": {
    "source": "https://mewithoutyou.bandcamp.com/album/live-vol-two",
    "tracks": [
      {
        "title": "Song #1",
        "seconds": 162
      },
      {
        "title": "Song #2",
        "seconds": 152
      },
      {
        "title": "Song #3",
        "seconds": 246
      },
      {
        "title": "Song #4",
        "seconds": 225
      },
      {
        "title": "Song #5",
        "seconds": 221
      },
      {
        "title": "Song #6",
        "seconds": 109
      },
      {
        "title": "Song #7",
        "seconds": 182
      },
      {
        "title": "Song #8",
        "seconds": 251
      },
      {
        "title": "Song #9",
        "seconds": 234
      },
      {
        "title": "Song #10",
        "seconds": 68
      },
      {
        "title": "Song #11",
        "seconds": 252
      },
      {
        "title": "Song #12",
        "seconds": 209
      },
      {
        "title": "Song #13",
        "seconds": 204
      },
      {
        "title": "Song #14",
        "seconds": 238
      },
      {
        "title": "Song #15",
        "seconds": 186
      },
      {
        "title": "Song #16",
        "seconds": 219
      },
      {
        "title": "Song #17",
        "seconds": 397
      },
      {
        "title": "Song #18",
        "seconds": 183
      },
      {
        "title": "Song #19",
        "seconds": 186
      },
      {
        "title": "Song #20",
        "seconds": 255
      }
    ]
  },
  "live-vol-three": {
    "source": "https://mewithoutyou.bandcamp.com/album/live-vol-three",
    "tracks": [
      {
        "title": "Song #1",
        "seconds": 256
      },
      {
        "title": "Song #2",
        "seconds": 176
      },
      {
        "title": "Song #3",
        "seconds": 245
      },
      {
        "title": "Song #4",
        "seconds": 231
      },
      {
        "title": "Song #5",
        "seconds": 318
      },
      {
        "title": "Song #6",
        "seconds": 270
      },
      {
        "title": "Song #7",
        "seconds": 263
      },
      {
        "title": "Song #8",
        "seconds": 235
      },
      {
        "title": "Song #9",
        "seconds": 329
      },
      {
        "title": "Song #10",
        "seconds": 257
      },
      {
        "title": "Song #11",
        "seconds": 351
      },
      {
        "title": "Song #12",
        "seconds": 77
      },
      {
        "title": "Song #13",
        "seconds": 403
      },
      {
        "title": "Song #14",
        "seconds": 227
      },
      {
        "title": "Song #15",
        "seconds": 359
      },
      {
        "title": "Song #16",
        "seconds": 206
      },
      {
        "title": "Song #17",
        "seconds": 292
      }
    ]
  },
  "i-never-said-that-i-was-brave": {
    "source": "https://mewithoutyou.bandcamp.com/album/i-never-said-that-i-was-brave",
    "tracks": [
      {
        "title": "I Never Said That I Was Brave",
        "seconds": 177
      },
      {
        "title": "Flamethrower",
        "seconds": 174
      },
      {
        "title": "Dying is Strange and Hard",
        "seconds": 149
      },
      {
        "title": "We Know Who Our Enemies Are",
        "seconds": 166
      },
      {
        "title": "Four Word Letter",
        "seconds": 184
      }
    ]
  },
  "untitled-2": {
    "source": "https://mewithoutyou.bandcamp.com/album/untitled-2",
    "tracks": [
      {
        "title": "Bethlehem, WV",
        "seconds": 215
      },
      {
        "title": "Winter Solstice (alt. version)",
        "seconds": 204
      },
      {
        "title": "Dirty Air",
        "seconds": 201
      },
      {
        "title": "Cities of the Plain",
        "seconds": 304
      },
      {
        "title": "Existential Dread, Six Hours&#39; Time",
        "seconds": 204
      },
      {
        "title": "August 6th",
        "seconds": 207
      },
      {
        "title": "Kristy w/ the Sparkling Teeth",
        "seconds": 184
      }
    ]
  }
};
